import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppState } from '../../../../../reducers';
import {
  loadIndustryDescriptions,
  updateIndustryDescriptionsCurrentDatabaseId,
  updateIndustryDescriptionsSelectedDatabaseId,
} from '../drill-down.actions';
import { hasIndustryDescriptionsLoaded, selectIndustryDescriptions, selectIndustryDescriptionsSelectedDatabaseId } from '../drill-down.selectors';
import { DrillDownSectionBaseComponent } from './base/drill-down-section-base.component';

@Component({
  selector: 'app-drill-down-industry-descriptions',
  templateUrl: './industry-descriptions.component.html',
  styleUrls: ['./industry-descriptions.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class IndustryDescriptionsComponent extends DrillDownSectionBaseComponent implements OnInit, OnDestroy {
  industryDescriptions$: Observable<string[]>;
  industryDescriptionsSelectedDatabaseId$: Observable<number>;
  hasIndustryDescriptionsLoaded: boolean;

  constructor(store: Store<AppState>) {
    super(store);
  }

  override ngOnInit(): void {
    super.ngOnInit();

    this.industryDescriptions$ = this.store.pipe(select(selectIndustryDescriptions));

    this.industryDescriptionsSelectedDatabaseId$ = this.store.pipe(select(selectIndustryDescriptionsSelectedDatabaseId));

    this.store
      .pipe(takeUntil(this.destroy$))
      .pipe(select(hasIndustryDescriptionsLoaded))
      .subscribe((isLoaded) => {
        this.hasIndustryDescriptionsLoaded = isLoaded;
      });
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  onIndustryDescriptionsDatabaseChange(id: string) {
    const databaseId = +id;
    const comparableId = this.companyData.comparableId;

    this.store.dispatch(updateIndustryDescriptionsSelectedDatabaseId({ id: comparableId, databaseId }));

    if (this.hasIndustryDescriptionsLoaded) {
      this.store.dispatch(updateIndustryDescriptionsCurrentDatabaseId({ id: comparableId, databaseId }));
      return;
    }

    this.store.dispatch(loadIndustryDescriptions({ id: comparableId, uniqueId: this.companyData.uniqueId, databaseId }));
  }
}
